export default __webpack_public_path__ + "static/media/190629_192557_DSCN3043.4da525a7.JPG";